import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import OrderList from "../../Components/OrderList/OrderList";
import Footer from "../../Components/Common/Footer";
import { Redirect } from "react-router";
import SessionHelper from "../../Helper/SessionHelper";

class OrderListPage extends Component {
  constructor() {
    super();
    this.state = {
      RedirectWithoutLogin: false,
    };
  }

  pageRedirectWithoutLogin = () => {
    if (this.state.RedirectWithoutLogin === true) {
      return <Redirect to="/" />;
    }
  };
  CheckLogin = () => {
    let Login = SessionHelper.getLogin();
    if (Login !== "YES") {
      this.setState({ RedirectWithoutLogin: true });
    }
  };

  componentDidMount() {
    window.scroll(0, 0);
    this.CheckLogin();
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <OrderList />
        </div>
        <Footer />
        {this.pageRedirectWithoutLogin()}
      </Fragment>
    );
  }
}

export default OrderListPage;
